/********************************************************************
 * ADOBE CONFIDENTIAL
 * __________________
 *
 *  Copyright 2024 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 *******************************************************************/

import { handleNetworkError } from '@/auth/lib/network-error';
import { fetchGraphQl } from '../fetch-graphql';
import { RESET_PASSWORD } from './graphql/resetPassword.graphql';
import { transformResetPassword } from '@/auth/data/transforms/transform-reset-password';
import { ResetPasswordModel } from '@/auth/data/models';
import { ResetPasswordResponse } from '@/auth/types';
import { setReCaptchaToken } from '@/auth/lib/setReCaptchaToken';

export const resetPassword = async (
  email: string,
  resetPasswordToken: string,
  newPassword: string
): Promise<ResetPasswordModel> => {
  await setReCaptchaToken();

  return await fetchGraphQl(RESET_PASSWORD, {
    method: 'POST',
    variables: { email, resetPasswordToken, newPassword },
  })
    .then((response: ResetPasswordResponse) => {
      return transformResetPassword(response);
    })
    .catch(handleNetworkError);
};
